<section class="storyblok-blok-container">
  <div class="sub-category-grid" appIsVisible (isVisible)="initializeCategoryGridView()">
    <ng-container *ngIf="isMobile; else desktopGrid">
      <div
        [ngStyle]="{
        'height.px': showAllCategoriesButton ? (showAllCategories ? maxHeightMobile : minHeightMobile) : ''
      }"
        class="sub-category-grid__container"
      >
        <ng-container *ngTemplateOutlet="gridContainer"></ng-container>
      </div>
    </ng-container>
    <div *ngIf="showAllCategoriesButton" class="sub-category-grid__show-all">
      <div class="sub-category-grid__show-all__interaction-area" (click)="onShowAllClick()">
        {{ (showAllCategories ? 'SHARED.SHOW_LESS.LABEL' : 'CATALOG.CATALOG_PAGE.HUB.SHOW_ALL') | translate }}
        <mm-icon *ngIf="!showAllCategories" name="chevron-down"></mm-icon>
        <mm-icon *ngIf="showAllCategories" name="chevron-up"></mm-icon>
      </div>
    </div>
  </div>
</section>

<ng-template #desktopGrid>
  <ng-container *ngIf="isDesktop; else tabletGrid">
    <div
      [ngStyle]="{
        'height.px': showAllCategoriesButton ? (showAllCategories ? maxHeightDesktop : minHeightDesktop) : ''
      }"
      class="sub-category-grid__container"
    >
      <ng-container *ngTemplateOutlet="gridContainer"></ng-container>
    </div>
  </ng-container>
</ng-template>

<ng-template #tabletGrid>
  <div
    [ngStyle]="{
      'height.px': showAllCategoriesButton ? (showAllCategories ? maxHeightTablet : minHeightTablet) : ''
    }"
    class="sub-category-grid__container"
  >
    <ng-container *ngTemplateOutlet="gridContainer"></ng-container>
  </div>
</ng-template>

<ng-template #gridContainer>
  <div class="sub-category-grid__grid">
    <app-sub-category-card
      *ngFor="let category of categories | slice: 0:limit"
      [category]="category"
      [parentCategoryName]="parentCategoryName"
      [isMobile]="isMobile"
      @fadeIn
    ></app-sub-category-card>
  </div>
</ng-template>
